import './datepicker/datepicker-en-NZ.js';
import './datepicker/datepicker-en-GB.js';
import './datepicker/datepicker-en-AU.js';
import './parsley/en.js';
import './parsley/en.extra.js';
import './languageformat/languageformat.js';
